import { Component, Input } from '@angular/core';

export type GeoLoaderPosition = 'inline' | 'absolute' | 'fixed';

@Component({
  selector: 'app-geo-loader-new',
  templateUrl: './geo-loader-new.component.html',
  styleUrls: ['./geo-loader-new.component.scss'],
})
export class GeoLoaderNewComponent {
  @Input() showBg? = false;
  @Input() position: GeoLoaderPosition = 'fixed';
  @Input() size: string = '36px';
}
